export const MATRIX_TEMPLATE_STATUS = {
  PUBLISHED: 'published',
  DRAFT: 'draft'
};

export const getStatusColor = (status) => {
  switch (status) {
    case MATRIX_TEMPLATE_STATUS.PUBLISHED:
      return '#E6F4EA'; // Light green
    case MATRIX_TEMPLATE_STATUS.DRAFT:
      return '#F3F4F6'; // Light gray
    default:
      return '#F3F4F6';
  }
};

export const getStatusTextColor = (status) => {
  switch (status) {
    case MATRIX_TEMPLATE_STATUS.PUBLISHED:
      return '#1E8E3E'; // Green
    case MATRIX_TEMPLATE_STATUS.DRAFT:
      return '#6B7280'; // Gray
    default:
      return '#6B7280';
  }
};

export const getStatusText = (status) => {
  switch (status) {
    case MATRIX_TEMPLATE_STATUS.PUBLISHED:
      return 'Published';
    case MATRIX_TEMPLATE_STATUS.DRAFT:
      return 'Draft';
    default:
      return 'Unknown';
  }
}; 